import * as Sentry from '@sentry/react'

import { Register } from '@tanstack/react-router'

const DSN =
  'https://fc9bfe82ac1e7e2e9a992ebbf6e883fa@o112361.ingest.us.sentry.io/4508777032777728'

export const initializeSentry = (ops: { router: Register['router'] }) => {
  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.tanstackRouterBrowserTracingIntegration(ops.router),
    ],
    tracesSampleRate: 1.0,
  })
}
